export const PARSE = 'phone-parse';
export const COUNTRY_CHANGE = 'phone-country-change';
